export const API = {
    zomato : {
        baseUrl :'https://developers.zomato.com/api/v2.1',
        api_key : process.env.REACT_APP_API_KEY_ZOMATO
    }
}